import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { STORAGE_CUSTOMER } from '../constants';

@Injectable()
export class CartInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the customer is logged in or has cart key in local storage
    try {
      const cartKey = localStorage.getItem(STORAGE_CUSTOMER)
        ? JSON.parse(localStorage.getItem(STORAGE_CUSTOMER)).id
        : localStorage.getItem('cart')

      // If they have a cart key add it to the headers
      if (cartKey) {
        request = request.clone({
          setHeaders: { cart: cartKey && cartKey.toString() }
        });
      }

      // On cart responses, save the cart key to localstorage
      return next.handle(request).pipe(
        tap((response: HttpResponse<any>) => {
          if (response && response.body && response.body.cartKey) {
            const cartKey = response.body.cartKey
            if (!Number(cartKey)) {
              localStorage.setItem('cart', cartKey);
            } else {
              localStorage.removeItem('cart')
            }
          }
        })
      )
    } catch(e) {
      console.warn('cookies disabled?')
      return next.handle(request)
    }
  }
}